var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.943 13.538c.467 0 .85.345.915.802a5.604 5.604 0 006.923 4.628c2.1-.503 3.649-2.118 4.097-4.227A5.611 5.611 0 0012.4 7.94v2.603c0 .42-.504.626-.793.327L8.071 7.332a.462.462 0 010-.662l3.536-3.537a.467.467 0 01.793.336v2.604c4.61 0 8.25 4.18 7.316 8.958-.56 2.902-2.706 5.132-5.59 5.776-4.506 1.008-8.537-2.053-9.116-6.224-.084-.55.373-1.045.933-1.045z",
    fill: "currentColor"
  })));
}
export default SvgRepeat;